import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { VaFilterChipsModule, VaFilterModule, VaIconModule } from '@vendasta/uikit';
import { ManageProductTableComponent } from './manage-product-table/manage-product-table.component';

@NgModule({
  declarations: [ManageProductTableComponent],
  exports: [ManageProductTableComponent],
  imports: [
    CommonModule,
    MatTableModule,
    MatSortModule,
    RouterModule,
    VaIconModule,
    MatDividerModule,
    MatIconModule,
    VaFilterModule,
    VaFilterChipsModule,
    TranslateModule,
    MatButtonModule,
    MatTooltipModule,
  ],
})
export class ManageProductModule {}
